export const menuViewStyle = () => {
  return {
    outer: 'relative',
    sort: 'flex flex-row justify-end gap-3',
    section: 'pt-6 pb-12 grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-6',
  };
};
